import React, { useEffect } from 'react';
import withRouter from '@velzon/components/withRouter.js';
import { useSelector } from "react-redux";
import { getAuthorizationToken } from '@velzon/utils/auth/index.js';
import useRouter from '@velzon/Hooks/useRouter.js';
// import useCurrentUser from '@velzon/Hooks/useCurrentUser';

const NonAuthLayout = ({ children }) => {
  const {
    layoutModeType
  } = useSelector(state => ({
    layoutModeType: state.Layout.layoutModeType
  }));
  const router = useRouter();

  useEffect(() => {
    const token = getAuthorizationToken()

    if (token) {
      router.push("/dashboard");
    }
    if (layoutModeType === "dark") {
      document.body.setAttribute("data-layout-mode", "dark");
    } else {
      document.body.setAttribute("data-layout-mode", "light");
    }
    return () => {
      document.body.removeAttribute("data-layout-mode");
    };
  }, [layoutModeType]);
  return (
    <div>
      {children}
    </div>
  );
};

export default withRouter(NonAuthLayout);